import api from './api';
import { Order, ApiResponse } from '../types';

interface CreateOrderData {
  deliveryAddressId?: string;
  prescriptionId?: string;
  couponCode?: string;
  useLoyaltyPoints?: boolean;
  notes?: string;
  paymentMethod: string;
  orderType?: string;
}

interface RazorpayOrderResponse {
  order: Order;
  razorpayOrderId: string;
  amount: number;
  currency: string;
  keyId: string;
}

export const orderService = {
  createOrder: (data: CreateOrderData) =>
    api.post<ApiResponse<RazorpayOrderResponse>>('/orders', data),

  verifyPayment: (data: { razorpay_order_id: string; razorpay_payment_id: string; razorpay_signature: string }) =>
    api.post<ApiResponse<{ orderNumber: string }>>('/orders/verify-payment', data),

  getUserOrders: (page = 1, status?: string) =>
    api.get<ApiResponse<Order[]>>(`/orders?page=${page}${status ? `&status=${status}` : ''}`),

  getOrderDetail: (id: string) =>
    api.get<ApiResponse<Order>>(`/orders/${id}`),

  cancelOrder: (id: string) => api.put(`/orders/${id}/cancel`),

  downloadInvoice: (id: string) =>
    api.get(`/orders/${id}/invoice`, { responseType: 'blob' }),

  getAllOrders: (page = 1, status?: string) =>
    api.get<ApiResponse<Order[]>>(`/orders/all?page=${page}${status ? `&status=${status}` : ''}`),

  updateStatus: (id: string, status: string, description?: string) =>
    api.put(`/orders/${id}/status`, { status, description }),

  reorder: (id: string) => api.post(`/orders/${id}/reorder`),
};
